<template>
  <section class="employer-ask-question-section half-cut-bg">
    <AskYourCareTeamAdmin></AskYourCareTeamAdmin>
</section>
</template>

<script>
/* eslint-disable */
import AskYourCareTeamAdmin from '../common/customer-support/AskYourCareTeam.vue'

export default {
name: 'AskYourCareTeam',
components: { AskYourCareTeamAdmin },
data() {
  return {

  }
},
methods: {

},
mounted() {
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/admin/AskYourCareTeam.vue